module.exports = __webpack_public_path__ + "static/media/1.5a097768.jpg";